/* eslint-disable import/prefer-default-export */
export const getNamespaced = (namespace, items = {}) => {
  const objCopy = Object.assign({}, items);
  const namespacedItems = {};

  Object.keys(objCopy).forEach((key) => {
    namespacedItems[key] = `${namespace}/${objCopy[key]}`;
  });

  return namespacedItems;
};



// WEBPACK FOOTER //
// ./src/store/utils.js